import styled from 'styled-components';

export const InputColorPickerStyled = styled.div`
  .Polaris-TextField__Suffix {
    margin-right: 0.25rem;
    width: 35px;
  }
`;
